/// <reference types="@types/googlemaps" />
import {Component, Input, OnInit, ViewEncapsulation, ViewChild} from '@angular/core';
import { Travel } from '../../shared/models/travel/travel';
import { Point } from '../../shared/models/travel/point';
import { RoutePointType } from '../../shared/models/travel/route-point-type.enum';
import { MapPoint } from '../map/map.component';
import {TravelType} from '../../shared/models/travel/travel-type.enum';
import { StaticMaps } from '../../shared/models/static-maps';
import { MapModalComponent } from '../modal/map-modal/map-modal.component';
import {NewrelicService} from '../../services/newrelic/newrelic.service';
import {AppSettingsService} from "../../services/app-settings/app-settings.service";

@Component({
  	selector: 'transfers-map',
 	templateUrl: './transfers-map.component.html',
  	styleUrls: ['./transfers-map.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class TransfersMapComponent implements OnInit {

	@Input() travel: Travel;
	@Input() staticMaps: StaticMaps;

	public originTravelPoint: Point;
	public isAirportOriginTravelPoint: boolean;
	public isAirportDestinationTravelPoint: boolean;
	public destinationTravelPoint: Point;
	public mapPoints: MapPoint[] = [];
	public previewMapPoints: MapPoint[];
	public showMapModal = false;

	@ViewChild(MapModalComponent, {static: true}) mapModal: MapModalComponent;

	constructor(
		private newRelicService: NewrelicService,
		private appSettings: AppSettingsService
	) {}

	ngOnInit(): void {
		this.initMapPoints();
	}

	initMapPoints(): void {
		this.originTravelPoint = this.travel && this.travel.points.length > 0 ? this.travel.points[0] : null;
		this.destinationTravelPoint = this.travel && this.travel.points.length > 1 ? this.travel.points[1] : null;

		this.isAirportOriginTravelPoint = this.isAirport(this.originTravelPoint);
		this.isAirportDestinationTravelPoint = this.isAirport(this.destinationTravelPoint);

		const origin = this.createMapPoint(this.originTravelPoint);
		const destination = this.createMapPoint(this.destinationTravelPoint);

		if (origin != null && destination != null) {
			this.mapPoints = [origin, destination];
		}

		const previewMapOriginPoint = Object.assign({}, origin);
		previewMapOriginPoint.infoWindowContent = '';
		const previewMapDestinationPoint = Object.assign({}, destination);
		previewMapDestinationPoint.infoWindowContent = '';
		this.previewMapPoints = [previewMapOriginPoint, previewMapDestinationPoint];
	}

	createMapPoint(travelPoint: Point): MapPoint {
		let mapPoint: MapPoint = null;
		if (travelPoint != null) {
			const infoWindowAddress = travelPoint.type !== RoutePointType.AIRPORT ? travelPoint.location.address : '';
			mapPoint = {
				location: {
					latitude: travelPoint.location.latitude,
					longitude: travelPoint.location.longitude
				},
				pointIcon: this.isAirportTravelPointType(travelPoint.type) ? 'flights-ui' : 'poi',
				isActive: !this.isAirportTravelPointType(travelPoint.type),
				infoWindowContent: this.createInfoContent(travelPoint.description, infoWindowAddress)
			};
		}
		return mapPoint;
	}
	isAirportTravelPointType(travelPointType): boolean {
		return travelPointType === RoutePointType.AIRPORT;
	}

	createInfoContent(description: string, address?: string): string {
		return '<div class="marker-info-content"><div class="bold">' + description + '</div>' + (address ? address : '') + '</div>';
	}

	isAirport(point: Point) {
		return point != null && point.type === RoutePointType.AIRPORT;
	}

	openModal() {
		this.showMapModal = true;
		this.trackNewRelicOpenMapEvt();
	}

	closeModal() {
		this.showMapModal = false;
	}

	private trackNewRelicOpenMapEvt(): void {
		this.newRelicService.trackToInsights('OpenMap', {
			channel: this.appSettings.getChannel(),
			site: this.appSettings.getSite(),
			lang: this.appSettings.getLanguage()
		});
	}

}
